var React = require('react');

function LinkedinInIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M5.47,24.436H.4V8.122H5.47ZM2.934,5.9A2.948,2.948,0,1,1,5.868,2.935,2.959,2.959,0,0,1,2.934,5.9Zm21.5,18.539H19.375V16.494c0-1.893-.038-4.32-2.634-4.32-2.634,0-3.038,2.056-3.038,4.183v8.078H8.643V8.122H13.5v2.225h.071a5.323,5.323,0,0,1,4.793-2.634c5.127,0,6.07,3.376,6.07,7.762v8.962Z","transform":"translate(0 0)","fill":"#fff"}));
}

LinkedinInIcon.defaultProps = {"width":"24.436","height":"24.435","viewBox":"0 0 24.436 24.435"};

module.exports = LinkedinInIcon;

LinkedinInIcon.default = LinkedinInIcon;
